var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoTipBeta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47754 2 2 6.47915 2 12C2 17.5241 6.47754 22 12 22C17.5225 22 22 17.5241 22 12C22 6.47915 17.5225 2 12 2ZM12 20.0645C7.54306 20.0645 3.93548 16.4584 3.93548 12C3.93548 7.54456 7.54323 3.93548 12 3.93548C16.4553 3.93548 20.0645 7.54319 20.0645 12C20.0645 16.4569 16.4584 20.0645 12 20.0645ZM12 6.43548C12.9353 6.43548 13.6935 7.19371 13.6935 8.12903C13.6935 9.06435 12.9353 9.82258 12 9.82258C11.0647 9.82258 10.3065 9.06435 10.3065 8.12903C10.3065 7.19371 11.0647 6.43548 12 6.43548ZM14.2581 16.6774C14.2581 16.9446 14.0414 17.1613 13.7742 17.1613H10.2258C9.95859 17.1613 9.74194 16.9446 9.74194 16.6774V15.7097C9.74194 15.4425 9.95859 15.2258 10.2258 15.2258H10.7097V12.6452H10.2258C9.95859 12.6452 9.74194 12.4285 9.74194 12.1613V11.1935C9.74194 10.9263 9.95859 10.7097 10.2258 10.7097H12.8065C13.0737 10.7097 13.2903 10.9263 13.2903 11.1935V15.2258H13.7742C14.0414 15.2258 14.2581 15.4425 14.2581 15.7097V16.6774Z",
    fill: "#0073BF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTipBeta);
export default __webpack_public_path__ + "static/media/info_tip_beta.cdc662dd0f8829a6d6a2158b2fe84907.svg";
export { ForwardRef as ReactComponent };